import React from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router"
import { ErrorBoundary } from "~/components/ErrorBoundary"
import { ErrorFallback } from "~/components/ErrorFallback"

import "./index.scss"
import ReactQueryProvider from "./react-query-provider.tsx"
import { router } from "./router.tsx"

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={() => <ErrorFallback className="h-screen" />}>
      <ReactQueryProvider>
        <RouterProvider router={router} />
      </ReactQueryProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
